//
//
//
//
//
//

import PrivacyPage from '@/components/page/PrivacyPage.vue'
export default {
  name: 'Privacy',
  layout: 'privacy',
  components: { PrivacyPage },
  data() {
    return {
      pageHash: 'privacy_agreement',
    }
  },
  created() {
    this.$nuxt.$on('change-page', (url) => {
      this.pageHash = url
    })
  },
  mounted() {
    this.pageHash = this.$route.hash.length
      ? this.$route.hash.substring(1)
      : 'privacy_agreement'
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$getTextSetting('title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
        dir: this.$direction(),
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$getTextSetting('description'),
        },
        {
          name: 'robots',
          content: 'noindex,nofollow',
        },
      ],
    }
  },
}
